import { render, staticRenderFns } from "./ModalStudentTimetableGroup.vue?vue&type=template&id=45475c6b&scoped=true&lang=pug&"
import script from "./ModalStudentTimetableGroup.vue?vue&type=script&lang=ts&"
export * from "./ModalStudentTimetableGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ModalStudentTimetableGroup.vue?vue&type=style&index=0&id=45475c6b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45475c6b",
  null
  
)

export default component.exports